import React, { useState } from 'react';
import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors,
	DragOverlay
} from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy
} from '@dnd-kit/sortable';

import { SortableItem } from './SortableItem';
import * as S from './styles';
import { color } from 'styles/pallete';

export default function DnDSortalbe() {
	const [items, setItems] = useState([1, 2, 3]);
	const [items2, setItems2] = useState([4, 5, 6]);

	const [activeId, setActiveId] = useState(null);
	const [draggingElement, setDraggingElement] = useState<any>(null);

	const sensors = useSensors(
		useSensor(PointerSensor),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates
		})
	);

	function handleDragStart(event: any) {
		const { active } = event;
		setActiveId(active.id);

		const activeElement = document.querySelector(`[data-id="${active.id}"]`);
		if (activeElement) {
			setDraggingElement(activeElement.outerHTML);
		}
	}

	function handleDragEnd(event: any) {
		const { active, over } = event;

		setActiveId(null);
		setDraggingElement(null);

		if (!over || active.id === over.id) return;

		const activeContainer = items.includes(active.id) ? 'items' : 'items2';
		const overContainer = items.includes(over.id) ? 'items' : 'items2';

		if (activeContainer === overContainer) {
			// Movimento dentro da mesma lista
			if (activeContainer === 'items') {
				setItems((prevItems) => {
					const oldIndex = prevItems.indexOf(active.id);
					const newIndex = prevItems.indexOf(over.id);
					return arrayMove(prevItems, oldIndex, newIndex);
				});
			} else {
				setItems2((prevItems) => {
					const oldIndex = prevItems.indexOf(active.id);
					const newIndex = prevItems.indexOf(over.id);
					return arrayMove(prevItems, oldIndex, newIndex);
				});
			}
		} else {
			// Movimento entre listas
			if (activeContainer === 'items') {
				setItems((prevItems) => prevItems.filter((item) => item !== active.id));
				setItems2((prevItems) => {
					const newIndex = prevItems.indexOf(over.id);
					const updatedItems = [...prevItems];
					if (newIndex === -1) {
						updatedItems.push(active.id);
					} else {
						updatedItems.splice(newIndex, 0, active.id);
					}
					return updatedItems;
				});
			} else {
				setItems2((prevItems) =>
					prevItems.filter((item) => item !== active.id)
				);
				setItems((prevItems) => {
					const newIndex = prevItems.indexOf(over.id);
					const updatedItems = [...prevItems];
					if (newIndex === -1) {
						updatedItems.push(active.id);
					} else {
						updatedItems.splice(newIndex, 0, active.id);
					}
					return updatedItems;
				});
			}
		}
	}

	function handleDragOver(event: any) {
		const { active, over } = event;

		if (!over) return;

		const { id: activeId } = active;
		const { id: overId } = over;

		// Identificar em qual lista o item está
		const activeContainer = items.includes(activeId) ? 'items' : 'items2';
		const overContainer = items.includes(overId) ? 'items' : 'items2';

		// Caso os containers sejam diferentes, movimentar o item
		if (activeContainer !== overContainer) {
			if (activeContainer === 'items' && overContainer === 'items2') {
				// Movendo de items para items2
				setItems((prevItems) => prevItems.filter((item) => item !== activeId));
				setItems2((prevItems2) => [...prevItems2, activeId]);
			} else if (activeContainer === 'items2' && overContainer === 'items') {
				// Movendo de items2 para items
				setItems2((prevItems2) =>
					prevItems2.filter((item) => item !== activeId)
				);
				setItems((prevItems) => [...prevItems, activeId]);
			}
		}
	}

	function handleDragCancel() {
		setActiveId(null);
		setDraggingElement(null);
	}

	return (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragStart={handleDragStart}
			onDragEnd={handleDragEnd}
			onDragCancel={handleDragCancel}
			onDragOver={handleDragOver} // Adicionando a função de drag over
		>
			<S.container>
				<S.list>
					<SortableContext
						id="items"
						items={items}
						strategy={verticalListSortingStrategy}
					>
						{items.map((id) => (
							<SortableItem id={id} key={id}>
								<p>{id}</p>
							</SortableItem>
						))}
					</SortableContext>
				</S.list>

				<S.list>
					<SortableContext
						id="items2"
						items={items2}
						strategy={verticalListSortingStrategy}
					>
						{items2.map((id) => (
							<SortableItem id={id} key={id}>
								<p>{id}</p>
							</SortableItem>
						))}
					</SortableContext>
				</S.list>

				<DragOverlay>
					{activeId && draggingElement && (
						<div
							dangerouslySetInnerHTML={{ __html: draggingElement }}
							style={{
								pointerEvents: 'none',
								backgroundColor: color.interface.onDragColor,
								cursor: 'grabbing',
								padding: '10px',
								borderRadius: '8px',
								boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)'
							}}
						/>
					)}
				</DragOverlay>
			</S.container>
		</DndContext>
	);
}
